import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import StarIcon from "@mui/icons-material/Star";
import "./PainterServiceSections.css";

const PainterTestimonials = ({ data }) => {
  const getInitial = (name) => name?.trim()?.charAt(0)?.toUpperCase() || "G";

  return (
    <section className="pnt-testimonials">
      <div className="pnt-container">
        <div className="pnt-section-head">
          <span className="pnt-tag">Customer Stories</span>
          <h2 className="pnt-heading">{data.title}</h2>
          <p className="pnt-subheading">{data.titleDesc}</p>
        </div>

        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={22}
          slidesPerView={1}
          loop={true}
          pagination={{ clickable: true }}
          autoplay={{ delay: 3500, disableOnInteraction: false, pauseOnMouseEnter: true }}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1100: { slidesPerView: 3 },
          }}
          className="pnt-testimonial-swiper"
        >
          {data.main.map((customer, index) => (
            <SwiperSlide key={index}>
              <div className="pnt-testimonial-card">
                <FormatQuoteIcon className="pnt-testimonial-quote-icon" />
                <div className="pnt-testimonial-stars">
                  {[...Array(5)].map((_, i) => (
                    <StarIcon key={i} fontSize="inherit" />
                  ))}
                </div>
                <p className="pnt-testimonial-feedback">{customer.feedback}</p>
                <div className="pnt-testimonial-person">
                  <span className="pnt-testimonial-avatar">{getInitial(customer.name)}</span>
                  <div>
                    <strong>{customer.name}</strong>
                    <span>{customer.location}</span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default PainterTestimonials;
